import { mainApiInstance } from "../_axiosInstance";

type UploadPresignedUrlResponse = {
  presignedUrlThumbnail: string;
  presignedUrlOriginal: string;
  keyThumbnail: string;
  keyOriginal: string;
};

const uploadAvatar = async (thumbnailFile: File, originalFile: File) => {
  try {
    const formData = new FormData();
    formData.append("file", thumbnailFile);
    const uploadPresignedUrlRes =
      await mainApiInstance.post<UploadPresignedUrlResponse>(
        "/users/avatar/upload-url",
        {
          fileExtension: thumbnailFile.name.split(".").pop(),
        },
      );
    const uploadPresignedUrl = uploadPresignedUrlRes.data;
    const thumbnailUploadPromise = fetch(
      uploadPresignedUrl.presignedUrlThumbnail,
      {
        method: "PUT",
        body: thumbnailFile,
        headers: {
          "Content-Type": thumbnailFile.type,
        },
      },
    );

    const originalUploadPromise = fetch(
      uploadPresignedUrl.presignedUrlOriginal,
      {
        method: "PUT",
        body: originalFile,
        headers: {
          "Content-Type": originalFile.type,
        },
      },
    );
    const [thumbnailUploadRes, originalUploadRes] = await Promise.all([
      thumbnailUploadPromise,
      originalUploadPromise,
    ]);
    if (!thumbnailUploadRes.ok || !originalUploadRes.ok) {
      throw new Error("Failed to upload avatar", {
        cause: thumbnailUploadRes || originalUploadRes || "Unknown error",
      });
    }
    return {
      thumbnailUploadRes,
      originalUploadRes,
    };
  } catch (error) {
    throw error;
  }
};

type UpdatePasswordRequest = {
  currentPassword: string;
  newPassword: string;
};

const updatePassword = async (data: UpdatePasswordRequest) => {
  try {
    const response = await mainApiInstance.post("/users/update-password", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateCustomerId = async (customerId: string) => {
  try {
    const response = await mainApiInstance.put("/users/payment-customer-id", {
      paymentCustomerId: customerId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const usersService = {
  uploadAvatar,
  updatePassword,
  updateCustomerId,
};
